import React from "react";
export default function IlluminatingFaithForTheYouth() {
  return <section data-section-id="224343" id="kurumsal-giris" className="bg-[#090909] text-[#f4efe5]">
      <div className="mx-auto grid min-h-[calc(76svh-80px)] max-w-[1320px] gap-10 px-5 py-14 sm:px-8 md:min-h-[calc(82svh-80px)] md:py-18 lg:grid-cols-[minmax(0,0.34fr)_minmax(0,0.66fr)] lg:px-10 lg:py-24">
        <div aria-hidden="true" className="hidden min-w-0 border-t border-[#f4efe5]/14 lg:block" />
        <div className="flex min-w-0 items-end border-t border-[#f4efe5]/14 pt-8 pr-1 sm:pr-2 lg:pt-10 lg:pr-8 xl:pr-12">
          <h1 className="w-full max-w-[8.9ch] font-serif text-[clamp(2.85rem,11.2vw,8.85rem)] font-normal leading-[0.88] tracking-[-0.038em] text-[#f4efe5]">
            <span className="block">Yüksekbaş</span>
            <span className="block">Hukuk ve</span>
            <span className="block">Danışmanlık</span>
          </h1>
        </div>
      </div>
    </section>;
}